<!--
 * @Date: 2025-04-07 11:47:39
 * @LastEditors: 'lidianbin' 'lidianbin@coocaa.com'
 * @LastEditTime: 2025-06-17 16:26:23
 * @FilePath: \ccms\packages\cms-components\lib\components\advanceImgTxtFour\TextContent.vue
-->
<template>
  <div
    :style="{
      textAlign: textAlign,
      width: layoutWidth + 'px',
      backgroundColor: textConfig.bgColor
    }"
    class="text-container"
  >
    <div
      :class="{
        'text-content--wrap': cardStructure !== 'full-cover'
      }"
      :style="textWrapStyle"
    >
      <div
        class="text-image"
        :style="getImageStyle(textConfig.textImage)"
        v-if="cardData.textImage && textConfig.textImage.show"
      >
        <coocaa-image :src="cardData.textImage"></coocaa-image>
      </div>
      <div
        class="line-clamp"
        v-if="textConfig.label.show"
        :class="getFontClass(textConfig.label)"
        :style="getFontStyle(textConfig.label, 1)"
        v-bind="genAnimationAttrs(textConfig.label.scrollAnimation)"
      >
        <span :style="getLabelStyle(textConfig.label)" v-html="cardData.labelText"></span>
      </div>
      <div
        class="line-clamp"
        v-if="textConfig.title.show"
        :class="getFontClass(textConfig.title)"
        :style="getFontStyle(textConfig.title)"
        v-bind="genAnimationAttrs(textConfig.title.scrollAnimation)"
        v-html="cardData.titleText"
      ></div>
      <div
        class="line-clamp"
        v-if="textConfig.subtitle.show"
        :class="getFontClass(textConfig.subtitle)"
        :style="getFontStyle(textConfig.subtitle)"
        v-bind="genAnimationAttrs(textConfig.subtitle.scrollAnimation)"
        v-html="cardData.subtitleText"
      ></div>
      <div :style="transfCssUtil(cardData.btns.css)">
        <div
          class="btn-item"
          v-for="(btn, b_index) of cardData.btns.list"
          :class="{'is-hover': btn.url}"
          :key="b_index"
          :style="getBtnStyle(btn.btnCss)"
          @click.prevent.stop="openUrl(btn)"
        >
          <span :style="btn.fontCss">{{ btn.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { arrToPx, transfCssUtil, genAnimationAttrs } from '../../utils/index'
export default {
  props: {
    cardStructure: {
      type: String
    },
    cardData: {
      type: Object,
      default: () => ({})
    },
    textConfig: {
      type: Object,
      required: true
    },
    textAlign: {
      type: String,
      default: 'left'
    },
    layoutWidth: {
      type: [Number, String],
      default: 'auto'
    }
  },
  data () {
    return {
      transfCssUtil
    }
  },
  computed: {
    textWrapStyle () {
      const padding = arrToPx(this.textConfig.padding).split(' ')
      return this.cardStructure === 'full-cover' ? {} : {
        padding: padding.join(' '),
        height: `calc(100% - ${padding[0] || 0} - ${padding[2] || 0})`
      }
    }
  },
  methods: {
    genAnimationAttrs,
    getImageStyle (data) {
      return {
        width: data.width ? `${data.width}px` : '',
        height: data.height ? `${data.height}px` : '',
        margin: data.margin ? arrToPx(data.margin) : '',
        padding: data.padding ? arrToPx(data.padding) : ''
      }
    },
    getBtnStyle (btn) {
      return this.transfCssUtil(btn)
    },
    openUrl ({ url }) {
      if (url) {
        window.open(url)
      }
    },
    getFontClass ({ fontSize, fontWeight }) {
      return `c-font-${fontWeight}-${fontSize}`
      //'c-font-' + fontWeight + '-' + fontSize
    },
    getLabelStyle ({ gradientColor, isGradient, color }) {
      const css = isGradient
        ? {
          backgroundImage: gradientColor,
          color: '#0000',
          display: 'inline-block',
          'background-clip': 'text',
          '-webkit-background-clip': 'text',
        }
        : {
          color
        }
      return css
    },
    getFontStyle ({ color, fontSize, heightNum, padding }) {
      // arrToPx(padding)
      const fontsizeMap = {
        12: 18,
        13: 20,
        14: 22,
        16: 24,
        18: 28,
        20: 30,
        22: 34,
        24: 38,
        26: 40,
        28: 44,
        30: 46,
        32: 50,
        34: 52,
        36: 56,
        38: 58,
        40: 62,
        42: 66,
        44: 68,
        46: 72,
        48: 74,
        56: 86,
        64: 100,
        72: 112
      }
      const css = {
        color,
        padding: padding ? arrToPx(padding) : '',
        height: heightNum ? `${fontsizeMap[fontSize] * heightNum}px` : '',
        '-webkit-line-clamp': heightNum,
        'line-clamp': heightNum
      }
      return css
    }
  }
}
</script>

<style scoped lang="stylus">
.text-content--wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
}
.line-clamp
  display -webkit-box
  overflow hidden
  text-overflow ellipsis
  -webkit-box-orient vertical
  white-space pre-line
  // -webkit-line-clamp 1
.gradient-text {
  background: linear-gradient(to right, #ff0000, #00ff00);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.btn-item {
  // display: inline-block;
  // text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  &.is-hover {
    cursor: pointer;
  }
}
</style>
